import {
  Fragment, useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  ProjectOutlined,
  ApiOutlined,
  DashboardOutlined,
  BarChartOutlined,
  ArrowRightOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByKey: Record<string, JSX.Element> = {
  plan: <ProjectOutlined />,
  integrate: <ApiOutlined />,
  operate: <DashboardOutlined />,
  report: <BarChartOutlined />,
};

interface WorkflowFlowProps {
  className?: string;
  variant?: "default" | "compact";
}

const WorkflowFlow = ({ className = "", variant = "default" }: WorkflowFlowProps) => {
  const { t } = useTranslation("erpMini");
  const isCompact = variant === "compact";

  const steps = useMemo(() => {
    const raw = t("workflow.steps", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string; label: string }>;
  }, [t]);

  return (
    <div
      className={[
        "dev-erpMini-workflow-grid",
        isCompact ? "dev-erpMini-workflow--compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dev-erpMini-workflow-track">
        {steps.map((step, idx) => (
          <Fragment key={step.key}>
            {isCompact ? (
              <div className="dev-erpMini-step-item">
                <div className={`dev-erpMini-step-card dev-erpMini-step-card--${step.key}`}>
                  <div className="dev-erpMini-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                </div>
                <div className="dev-erpMini-step-title">{step.label}</div>
              </div>
            ) : (
              <div className={`dev-erpMini-step-card dev-erpMini-step-card--${step.key}`}>
                <div className="dev-erpMini-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                <div className="dev-erpMini-step-title">{step.label}</div>
              </div>
            )}
            {idx < steps.length - 1 && (
              <div className="dev-erpMini-step-connector" aria-hidden>
                <ArrowRightOutlined />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowFlow;
